import { api } from "@services/baseURL";

// Troca o access_token do Entra ID por JWT interno + perfil
export const TrocarTokenPorJwt = async (accessToken, authMode = 'sso') => {
  try {
    const { data } = await api.post(
      'Auth/login',
      {}, // body vazio
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Auth-Mode': authMode,
        }
      }
    );
    return data;

  } catch (error) {
    throw error;
  }
};

export const RefreshToken = async () => {
  try {
    const response = await api.get('Auth/refresh');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados do usuário logado no refresh token:', error);
    throw error;
  }
};

export const GetUsuarioSessao = async () => {
  try {
    const response = await api.get('Auth/token-details');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados do usuário logado:', error);
    throw error;
  }
};

export const LogoutAPI = async () => {
  try {
    const response = await api.post("Auth/logout", {}) // remove o cookie HttpOnly
    return response.data;
  } catch (err) {
    console.warn("Erro ao apagar cookie", err);
    throw err;
  }
};

export default {
  TrocarTokenPorJwt,
  GetUsuarioSessao,
  RefreshToken,
  LogoutAPI
}